<template>
  <v-card class="ors-card">
    <div class="ors-card-border">
      <div class="ors-card-border-inner" />
    </div>
    <VCardText>
      <div
        v-if="title"
        class="ors-card-title"
      >
        {{ title }}
      </div>
      <div class="ors-card-content">
        <slot />
      </div>
      <div class="ors-card-footer">
        <hr>
        <v-row
          class="ors-card-footer-inner"
          justify="center"
        >
          <slot name="footer" />
        </v-row>
      </div>
    </VCardText>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
@import '~@/style/variables.css';

.ors-card {
  position: relative;
}
.ors-card .ors-card-border {
  position: absolute;
  overflow: hidden;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 10px;
}
.ors-card .ors-card-border .ors-card-border-inner {
  position: absolute;
  display: block;
  left: 0;
  height: 100%;
  width: 4px;
  background-color: var(--primary-color-3);
}
.ors-card .ors-card-content {
  color: var(--primary-color-1);
  font-size: 11px;
  font-family: 'Encode Sans', sans-serif;
}
.ors-card .ors-card-content /deep/ .v-list .v-list-item {
  padding-left: 0;
  padding-right: 0;
}
.ors-card .ors-card-content /deep/ .v-list .v-list-item .v-list-item__icon {
  margin-right: 0;
  color: var(--primary-color-1);
}
.ors-card .ors-card-content /deep/ .v-list .v-list-item .v-list-item__title {
  white-space: normal;
}
.ors-card .ors-card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Encode Sans', sans-serif;
  color: var(--primary-color-3);
}

.ors-card .ors-card-footer {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.ors-card .ors-card-footer hr {
  margin: 16px 0;
  color: #fff;
  opacity: .16;
}
.ors-card .ors-card-footer .ors-card-footer-inner /deep/ .v-btn {
  color: var(--dash-color-3);
  font-weight: normal;
}
.ors-card .ors-card-footer .ors-card-footer-inner /deep/ .v-btn + .v-btn {
  margin-left: 8px;
}
</style>
